import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from '@env';

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(() => {
      // if ('serviceWorker' in navigator && environment.production) {
      if (navigator && 'serviceWorker' in navigator && window) {
        window.addEventListener('load', () => {
          navigator.serviceWorker.register('firebase-messaging-sw.js');
          if (!environment.local) {
            navigator.serviceWorker.register('ngsw-worker.js');
          }
        });
      }
    })
    .catch(err => console.error(err));
});
